import React from 'react';
import { DepartureBoardController } from "../controllers/DepartureBoardController";
import { BoardRequest, TrackWebboardRequest } from "../controllers/model/api";
import DepartureBoardComponent from "./DepartureBoardComponent";
import { Board } from "../controllers/model/api";
import { Logger } from '../util/Logger';
import GlobalConfiguration from '../controllers/model/GlobalConfiguration';
import { HelperFunctions } from '../util/HelperFunctions';
import { WebboardController } from '../controllers/WebboardController';

const sourceFileName = "ContainerComponent.tsx";

export interface ContainerState {
  board: Board;
}

export interface ContainerProps {
  extId: string;
  token: string;
  product?: number;
  platform?: string;
  direction?: string;
  line?: string;
  showRealtime?:string;
  trackRequest?:string;
  displayTrack?: string;
  isArrivalBoard?: boolean;
}

export class ContainerComponent extends React.Component<ContainerProps, ContainerState> {
  private dataAvailalbe = false;
  private interval: any;
  private offlineData = false;
  private isUnauthorized = false;
  // private counter:number = 0;
  public render() {
    GlobalConfiguration.Config = this.props.isArrivalBoard
      ? this.props.displayTrack === 'true'
        ? GlobalConfiguration.ConfigWithPlatformArrival
        : GlobalConfiguration.ConfigWithoutPlatformArrival
      : this.props.displayTrack === 'true'
        ? GlobalConfiguration.ConfigWithPlatform
        : GlobalConfiguration.ConfigWithoutPlatform;

    Logger.debug(sourceFileName, "rendering app component");

    if(this.props.showRealtime!==undefined && this.props.showRealtime==='false')
      GlobalConfiguration.showRealtime = false;

    if (this.dataAvailalbe && !this.offlineData) {
      return (
         <DepartureBoardComponent product={this.props.product} departureBoard={this.state.board} />
      );
    }
    else if (this.offlineData && this.dataAvailalbe) {
      return (
        <div>
          <h2 style={{ color: "#ba4040", textAlign: "center", margin: 0 }}>No Internet Connection</h2>
          <DepartureBoardComponent product={this.props.product} departureBoard={this.state.board} />
        </div>
      );
    }
    else if (this.isUnauthorized && !this.dataAvailalbe) {
      return (
        <div>
          <h1 style={{ color: "#ba4040", textAlign: "center", margin: 0 }}>Http Status Code 403: Unauthorized</h1>
        </div>
      );
    }
    else {
      return (
        <div>
          <h1 style={{ color: "#ba4040", textAlign: "center", margin: 0 }}>keine Daten</h1>
        </div>
      );
    }
  }
  componentDidMount() {

    //start intervall for fetching data periodically
    Logger.debug(sourceFileName, "Container sucessfully mounted, start data loading...");
    this.loadData();
    this.interval = setInterval(
      () => this.loadData(),
      GlobalConfiguration.RefreshIntervallMilliseconds
    );
  }
  componentWillUnmount() {
    //clear intervall if component unmounts to prevent memory leak errors
    clearInterval(this.interval);
  }
  async loadData() {
    this._fetchData()
      .then((response) => {
        Logger.debug(sourceFileName, `fetched new data!`);
        if (!HelperFunctions.checkForNullOrEmpty(response.entries)) {
          response.entries = [];
          response.entries.push(HelperFunctions.createNewBoardEntry(GlobalConfiguration.NoMoreDepartures));
        }
        // if(this.counter%2===0){
        //   response.infoHeader="!! Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus scelerisque vestibulum sapien id pharetra. Vestibulum arcu dolor, tempus eu nsectetur adipiscing elit. Phasellus scelerisque vestibulum sapien id pharetra";
        //   response.infoText="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus tincidunt faucibus venenatis. Duis tellus sem, malesuada ac tortor ut, porta volutpat metus. Donec et nulla eget nisi fermentum porta in vel enim. Sed non nisl lacus. Phasellus ultricies massa odio, id hendrerit diam rutrum quis. Nunc ac risus a tortor pellentesque maximus nec vel ligula. Donec non turpis convallis nulla dapibus finibus. Maecenas porttitor quis quam at rutrum. Ut vestibulum odio ac dolor finibus, non lacinia odio vulputate."
        // + "Duis tristique varius volutpat. Donec tellus leo, lacinia sed dignissim auctor, finibus quis augue. Aliquam in mauris sem. Ut ut risus congue arcu laoreet semper.Nulla facilisi. Proin placerat ante ligula, vitae facilisis urna volutpat et. Integer sagittis nibh lacinia est ultricies mattis.Vivamus in turpis urna. Sed tincidunt quis lorem vitae bibendum. Curabitur imperdiet porta neque hendrerit volutpat. Aliquam sit amet tellus dolor.Suspendisse imperdiet mi at magna pellentesque commodo.Duis nec ex laoreet, varius nisl at, finibus ligula."
        // + "Aenean sagittis eros ex, in dapibus purus egestas id. Nulla quis varius eros, eget euismod enim. Nulla vestibulum augue lectus, eu consectetur erat aliquet vel. In commodo sagittis placerat. Phasellus sit amet rutrum sapien.Interdum et malesuada fames ac ante ipsum primis.";
        // }
        // this.counter++;

       
        const newState: ContainerState = {
          board: response
        };
        this.dataAvailalbe = true;
        this.offlineData = false;
        this.setState(newState);
        if(this.props.trackRequest === undefined || this.props.trackRequest.toLowerCase() === "true")
             this._trackRequest();
      })
      .catch((reason) => {
        Logger.error(sourceFileName, `Something went wrong while fetching new data. Reason: ${reason}`);
        if (this.state != null) {
          const offlineState: ContainerState = {
            board: this.state.board
          };
          this.offlineData = true;
          this.setState(offlineState);
        }
      });
  }
  async _fetchData() {
    // var product: Product | undefined;
    // if (this.props.product === "Train")
    //   product = Product.train;
    // if (this.props.product === "Bus")
    //   product = Product.localBus;
    var bitwiseOr = HelperFunctions.createBitwiseOrValue(this.props.product?.toString())
   
    
    const request: BoardRequest = {
      extId: this.props.extId,
      products: bitwiseOr !== 0 ? bitwiseOr : undefined,
      direction: this.props.direction,
      lines: this.props.line,
      track: this.props.platform,
      maxJourneys: 15
    }
    
    let response: Board;

    if (this.props.isArrivalBoard === true) {
      response = await DepartureBoardController.getArrivalBoard(request, this.props.token);
    } else {
      response = await DepartureBoardController.getDepartureBoard(request, this.props.token);
    }

    if(GlobalConfiguration.showRealtime){
        response.entries.map(entry => {
          if(!HelperFunctions.checkForNullOrEmpty(entry.timeProg)){
            entry.timeProg = entry.time;
          }
          return entry;
        })
    }
    return response;
  }
  async _trackRequest(){
    const request: TrackWebboardRequest = {
      webboard: {
        requestParameters: propsToDict(this.props),
        stationId: this.props.extId,
      }
    };
    await WebboardController._trackRequest(request, this.props.token);
  }
}
function propsToDict(props:any): {[id:string]:string} {
  var dictionary: {[id:string]:string} = {};

  for (const key in props) {
      if (props[key] !== undefined) {
        dictionary[key] = props[key];
      }
  }

  return dictionary;
}



export default ContainerComponent;